import { useEditorStore } from '../../state/editorStore';
import { IconButton } from '../controls/PanelShell';

export function Toolbar() {
  const project = useEditorStore((s) => s.project);
  const renameProject = useEditorStore((s) => s.renameProject);
  const theme = useEditorStore((s) => s.theme);
  const setTheme = useEditorStore((s) => s.setTheme);
  const cutAtPlayhead = useEditorStore((s) => s.cutAtPlayhead);
  const rippleDeleteSelected = useEditorStore((s) => s.rippleDeleteSelected);
  const addCrossDissolveToSelected = useEditorStore((s) => s.addCrossDissolveToSelected);
  const snapEnabled = useEditorStore((s) => s.snapEnabled);
  const setSnapEnabled = useEditorStore((s) => s.setSnapEnabled);
  const setShowWindowManager = useEditorStore((s) => s.setShowWindowManager);
  const setInspectorTab = useEditorStore((s) => s.setInspectorTab);
  const isLeader = useEditorStore((s) => s.isLeader);
  const connectedTabs = useEditorStore((s) => s.connectedTabs);

  return (
    <header className="flex h-9 shrink-0 items-center gap-1 border-b border-hairline bg-panel px-2">
      <div className="mr-2 flex items-baseline gap-2">
        <span className="text-sm font-semibold tracking-tight text-accent">CineGrid</span>
        <input
          className="w-40 border-0 bg-transparent text-xs text-text-high outline-none hover:bg-raised focus:bg-raised"
          value={project.name}
          onChange={(e) => renameProject(e.target.value)}
        />
      </div>

      <div className="mx-1 h-5 w-px bg-hairline" />

      <IconButton title="Cut / Split (C)" onClick={cutAtPlayhead}>
        Cut
      </IconButton>
      <IconButton title="Ripple Delete (⌫)" danger onClick={rippleDeleteSelected}>
        Ripple ⌫
      </IconButton>
      <IconButton title="Add Cross Dissolve" onClick={addCrossDissolveToSelected}>
        Dissolve
      </IconButton>
      <IconButton title="Snap (S)" active={snapEnabled} onClick={() => setSnapEnabled(!snapEnabled)}>
        Snap
      </IconButton>

      <div className="ml-auto flex items-center gap-1">
        <span className="timecode mr-2 text-2xs text-text-low">
          {project.settings.width}×{project.settings.height} · {project.settings.frameRate}fps
          {connectedTabs.length > 1 ? ` · ${connectedTabs.length} tabs` : ''}
          {isLeader ? ' · leader' : ''}
        </span>
        <IconButton title="Window Manager" onClick={() => setShowWindowManager(true)}>
          Windows
        </IconButton>
        <button
          type="button"
          title="Export / Render"
          onClick={() => setInspectorTab('export')}
          className="bg-accent px-2.5 py-1 text-2xs font-semibold text-base hover:brightness-110"
        >
          Export
        </button>
        <IconButton
          title="Toggle theme"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        >
          {theme === 'dark' ? 'Light' : 'Dark'}
        </IconButton>
      </div>
    </header>
  );
}
